import { PencilIcon } from 'lucide-react'
import { useState } from 'react'

import { useGetPartnersPartnerIdPartnerAdminRelationships } from 'utils/web_api'

import { PartnerAdminRelationshipSheet } from './PartnerAdminRelationshipSheet'

interface PartnerAdminListCellProps {
  employerId: string
  partnerId: string
  partnerDisplayName?: string
}

const PartnerAdminListCell = ({
  employerId,
  partnerId,
  partnerDisplayName = 'Partner',
}: PartnerAdminListCellProps) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  // Fetch relationships to display
  const { data, refetch, isLoading } = useGetPartnersPartnerIdPartnerAdminRelationships(
    partnerId,
    { prospect_employer_id: employerId }
  )

  const relationships = data?.relationships ?? []

  if (isLoading) {
    return <span className='text-gray-400 italic'>Loading...</span>
  }

  const formatPartnerAdminDisplay = () => {
    if (relationships.length === 0) {
      return <span className='text-gray-400 italic'>No admins assigned</span>
    }

    return (
      <div className='space-y-1'>
        {relationships.map((rel) => (
          rel.partner_admin && (
            <div key={rel.id} className={`${rel.role === 'assignee' ? 'font-semibold' : 'text-gray-600'}`}>
              {rel.partner_admin.email}
            </div>
          )
        ))}
      </div>
    )
  }

  const handleUpdate = () => {
    refetch()
  }

  return (
    <>
      <div className='flex items-center gap-2'>
        <div className='flex-1 min-w-0'>
          {formatPartnerAdminDisplay()}
        </div>
        <button
          type='button'
          onClick={() => setIsSheetOpen(true)}
          className='inline-flex items-center justify-center text-indigo-600 hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 rounded'
          title='Manage partner admins'
        >
          <PencilIcon className='h-4 w-4' />
        </button>
      </div>

      <PartnerAdminRelationshipSheet
        employerId={employerId}
        partnerId={partnerId}
        partnerDisplayName={partnerDisplayName}
        isOpen={isSheetOpen}
        onClose={() => setIsSheetOpen(false)}
        onUpdate={handleUpdate}
      />
    </>
  )
}

export default PartnerAdminListCell
